/* unplugin-vue-components disabled */import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import formatAmount from '@/shared/formatAmount';
import TrackingData from '@/shared/reportDataTracking';
import { useUserStore } from '@/stores/modules/user';
import CouponRulesPopup from './coupon-rules-popup.vue';
export default {
    __name: 'coupon-popup',
    props: {
        value: Boolean,
        couponList: function() {
            return [];
        },
        eCouponCode: String
    },
    emits: [
        'close',
        'select-coupon'
    ],
    setup: function(__props, param) {
        var emit = param.emit;
        var props = __props;
        var userStore = useUserStore();
        var enterTime = ref(new Date());
        watch(function() {
            return props.value;
        }, function(val) {
            if (val) {
                TrackingData.trackPopup(_object_spread_props(_object_spread({}, userStore.commonData), {
                    popKindName: 'popup_cupon_select',
                    taskHandler: 'popup-show'
                }));
            } else {
                TrackingData.trackClick(_object_spread_props(_object_spread({}, userStore.commonData), {
                    popKindName: 'popup_cupon_select',
                    taskHandler: 'popup-quit',
                    eventIntervalSpan: new Date() - enterTime.value
                }));
            }
        });
        var onOpenedPopup = function() {
            console.log('open');
        };
        var onClosedPopup = function() {
            console.log('close');
        };
        var isCouponRulesShow = ref(false);
        var showCouponRules = function() {
            isCouponRulesShow.value = true;
        };
        var selectCoupon = function(val) {
            emit('select-coupon', val);
            TrackingData.trackClick(_object_spread_props(_object_spread({}, userStore.commonData), {
                popKindName: 'popup_cupon_select',
                taskHandler: 'popup-select'
            }));
        };
        return {
            __sfc: true,
            userStore: userStore,
            props: props,
            emit: emit,
            enterTime: enterTime,
            onOpenedPopup: onOpenedPopup,
            onClosedPopup: onClosedPopup,
            isCouponRulesShow: isCouponRulesShow,
            showCouponRules: showCouponRules,
            selectCoupon: selectCoupon,
            formatAmount: formatAmount,
            CouponRulesPopup: CouponRulesPopup
        };
    }
};
